import { css } from '@emotion/core';
import { borderRadii } from 'app/spacing';
import { motionTransition } from './motion';

export const FRAME_OPACITY_VAR = '--ai-grid-frame-opacity';
export const FRAME_TRANSITION_VAR = '--ai-grid-frame-transition';

export const gridFrameCss = css`
  .breakpoint-container {
    position: relative;
    isolation: isolate;
  }

  .breakpoint-container::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    border: 1px solid var(--color-border-medium-light);
    border-radius: ${borderRadii.standard};
    background-color: color-mix(
      in srgb,
      var(--color-border-light) 40%,
      transparent
    );
    background-image: radial-gradient(
      color-mix(in srgb, var(--color-border-medium) 60%, transparent) 1px,
      transparent 1.5px
    );
    background-size: 16px 16px;
    opacity: var(${FRAME_OPACITY_VAR}, 0);
    transition: var(${FRAME_TRANSITION_VAR}, none);
  }
`;

export const gridFrame = (panelMounted: boolean) =>
  panelMounted ? gridFrameCss : '';

export const gridFrameVars = (
  visible: boolean,
  reducedMotion: boolean
): Record<string, string> => ({
  [FRAME_OPACITY_VAR]: visible ? '1' : '0',
  [FRAME_TRANSITION_VAR]: motionTransition(['opacity'], reducedMotion),
});
